import type { Model, Disposable } from '@patsnap/tahiti-core';
import type { defineAsyncComponent } from 'vue';

export type AutoMountComponent = Parameters<typeof defineAsyncComponent>[0];

/**
 * 自动挂载状态
 */
export interface AutoMountState {
    /**
     * 循环挂载的组件名称
     */
    loopForNames: string[];
    /**
     * 组件映射
     */
    componentMap: Record<string, AutoMountComponent>;
    /**
     * 属性映射
     */
    attrMap: Record<string, Record<string, any>>;
}

export const AutoMountModel = Symbol('AutoMountModel');

/**
 * 自动挂载数据模型
 */
export interface AutoMountModel extends Model<AutoMountState>, Disposable {}

export const AutoMountManager = Symbol('AutoMountManager');

/**
 * 自动挂载管理器
 * @see {@link DialogAutoMounterManager}
 */
export interface AutoMountManager extends Disposable {
    /**
     * 更新组件
     */
    update(component: AutoMountComponent, props: Record<string, any>, listeners: Record<string, any>): void;
    /**
     * 切换组件打开状态
     */
    toggleOpenState(component: AutoMountComponent, open: boolean): void;
    /**
     * 是否打开组件
     */
    hasOpenDialog(): boolean;
    /**
     * 注销组件
     */
    unregister(component: AutoMountComponent): void;
}
